"use client";

import { useEffect } from "react";

/** Counts one public visit per browser session per job (avoids Strict Mode double-fire). */
export function JobViewTracker({ slug }: { slug: string }) {
  useEffect(() => {
    if (!slug || typeof window === "undefined") return;
    const key = `mr-job-view:${slug}`;
    try {
      if (sessionStorage.getItem(key)) return;
      sessionStorage.setItem(key, "1");
    } catch {
      // Private mode / blocked storage — still count the visit.
    }

    void fetch(`/api/jobs/${encodeURIComponent(slug)}/view`, {
      method: "POST",
      keepalive: true,
    }).catch(() => undefined);
  }, [slug]);

  return null;
}
